module.exports = __webpack_public_path__ + "static/img/pie2.230eaf24.jpg";